import $ from 'jquery';

import '../scripts/select2/i18n/en';
import '../scripts/select2/i18n/ru';
import '../scripts/select2/i18n/ua';
import '../scripts/select2/i18n/lt';
import '../scripts/select2/i18n/lv';
import '../scripts/select2/i18n/st';
import '../scripts/select2/i18n/th';
import '../scripts/select2/i18n/uz';
import '../scripts/select2/i18n/kz';

import '../scripts/select2/select2.customSelectionAdapter.min.js';

$.addInit(function(context) {
	var base = '.b-select';

	var CustomSelectionAdapter = $.fn.select2.amd.require("select2/selection/customSelectionAdapter");

	$.fn.select2.amd.require([
		'select2/utils',
		'select2/dropdown',
		'select2/dropdown/attachContainer',
		'select2/dropdown/search',
		'select2/dropdown/closeOnSelect',
		'select2/selection/placeholder',
		'select2/selection/search',
	] , function (Utils, DropdownAdapter, AttachContainer, DropdownSearch, closeOnSelect, Placeholder, Search ) {

		var oldRemoveChoice = Search.prototype.searchRemoveChoice;

		Search.prototype.searchRemoveChoice = function () {
			oldRemoveChoice.apply(this, arguments);
			this.$search.val('');
		};

		$(base, context).each(function(){
			var component = $(this);
			var select = component.find('select');
			var dataSelect = component.data('select');

			function setPlaceholder() {
				component.find('.select2-search__field').attr('placeholder', component.data('placeholder'));
			}
			let opts = {}

			switch (dataSelect) {
				case 'checkbox':
					opts = {
						// width: "100%",
						// closeOnSelect : false,
						closeOnSelect: true,
						allowHtml: true,
						minimumInputLength: component.data('minimum-length') || 0,
						dropdownParent: component,
						dropdownAdapter: Utils.Decorate(Utils.Decorate(DropdownAdapter, AttachContainer, Placeholder), closeOnSelect),
						language: document.documentElement.lang || 'en'
						// multiple: true,
					}
					if (component.data('matcher')) {
						if (typeof window[component.data('matcher')] === 'function') {
							opts.matcher = window[component.data('matcher')]
						}
					}
					select.select2(opts);
					select.on("select2:unselect", function (e) {

						if (!e.params.originalEvent) {
							return;
						}

						e.params.originalEvent.stopPropagation();
					});
					
					setPlaceholder();
					select.on('select2:close', setPlaceholder);

					break;
				case 'custom':
					opts = {
						closeOnSelect: true,
						allowHtml: true,
						minimumInputLength: component.data('minimum-length') || 0,
						dropdownParent: component,
						dropdownAdapter: Utils.Decorate(Utils.Decorate(DropdownAdapter, AttachContainer, Placeholder), closeOnSelect),
						language: document.documentElement.lang || 'en',

						selectionAdapter: CustomSelectionAdapter,
						templateSelection: colorText,
					}
					if (component.data('matcher')) {
						if (typeof window[component.data('matcher')] === 'function') {
							opts.matcher = window[component.data('matcher')]
						}
					}
					select.select2(opts);
					select.on("select2:unselect", function (e) {

						if (!e.params.originalEvent) {
							return;
						}

						e.params.originalEvent.stopPropagation();
					});
					
					setPlaceholder();
					select.on('select2:close', setPlaceholder);
					break;
				default:
					opts = {
						width: "100%",
						dropdownParent: component,
						dropdownAdapter: Utils.Decorate(Utils.Decorate(DropdownAdapter, AttachContainer), closeOnSelect),
						closeOnSelect: true,
						placeholder: component.data('placeholder') || null,
					}
					if (component.data('matcher')) {
						if (typeof window[component.data('matcher')] === 'function') {
							opts.matcher = window[component.data('matcher')]
						}
					}
					select.select2(opts);
			}

			function colorText(item) {
				return $('<span class="b-select-tag">' + item.text + '</span>');
			}
		});
	});
});
